// extracted by mini-css-extract-plugin
export default {"HowItWork":"HowItWork_HowItWork__EoKXm","HowItWorkList":"HowItWork_HowItWorkList__jJH7F"};